import * as React from 'react';
import { Switch } from 'react-router-dom';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { PrivateRoute } from '../../components/PrivateRoute';
import { LazyLoader } from '../../containers/LazyLoader';
import { lazyWithRetry } from '../../../shared/lazyWithRetry';

// Lazy per screen: the field editor pulls in pdf.js and react-rnd, which the list does not need.
const LazyDocuments = lazyWithRetry(() => import('./Documents').then(module => ({ default: module.Documents })));
const LazyPrepare = lazyWithRetry(() => import('./Prepare/Prepare').then(module => ({ default: module.Prepare })));
const LazyRecipients = lazyWithRetry(() =>
	import('./Recipients/Recipients').then(module => ({ default: module.Recipients }))
);
const LazySend = lazyWithRetry(() => import('./Send/Send').then(module => ({ default: module.Send })));
const LazyDetail = lazyWithRetry(() => import('./Detail/Detail').then(module => ({ default: module.Detail })));

export const LazyDocumentsRoute: React.FC = () => {
	const userSession = useUserSession();
	return (
		<Switch>
			<PrivateRoute path='/documents/:id/recipients' userSession={userSession}>
				<LazyLoader>
					<LazyRecipients />
				</LazyLoader>
			</PrivateRoute>
			<PrivateRoute path='/documents/:id/prepare' userSession={userSession}>
				<LazyLoader>
					<LazyPrepare />
				</LazyLoader>
			</PrivateRoute>
			<PrivateRoute path='/documents/:id/send' userSession={userSession}>
				<LazyLoader>
					<LazySend />
				</LazyLoader>
			</PrivateRoute>
			{/* After the more specific routes, and before the list, so /documents/:id lands here. */}
			<PrivateRoute path='/documents/:id' userSession={userSession}>
				<LazyLoader>
					<LazyDetail />
				</LazyLoader>
			</PrivateRoute>
			<PrivateRoute path='/documents' userSession={userSession}>
				<LazyLoader>
					<LazyDocuments />
				</LazyLoader>
			</PrivateRoute>
		</Switch>
	);
};
